import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const CLIENT_VERSION = process.env.REACT_APP_VERSION || "0.0.0";
const CLIENT_COMMIT = process.env.REACT_APP_BUILD_COMMIT || "unknown";
const CLIENT_BUILD_TIME = process.env.REACT_APP_BUILD_TIME || "unknown";

/**
 * Footer showing the running client build and (async) the server build.
 * If client and server versions diverge, we highlight in red — this is
 * the instant "stale deploy" indicator across environments.
 */
export default function VersionFooter() {
  const [server, setServer] = useState(null);
  const [mismatch, setMismatch] = useState(false);

  useEffect(() => {
    api.get("/version")
      .then(({ data }) => {
        setServer(data);
        setMismatch(!!data.commit && data.commit !== CLIENT_COMMIT);
      })
      .catch(() => setServer({ commit: "offline" }));
  }, []);

  return (
    <div
      data-testid="version-footer"
      className={`fixed bottom-0 right-0 z-40 text-[9px] font-mono-data tracking-widest px-2 py-1 border-l border-t ${
        mismatch ? "border-bear text-bear bg-[#2a0000]" : "border-[color:var(--border-default)] text-[#52525B] bg-[color:var(--bg-surface)]/80"
      }`}
      title={`Client ${CLIENT_COMMIT} · Server ${server?.commit || "?"} · Built ${CLIENT_BUILD_TIME}`}
    >
      v{CLIENT_VERSION} · CLI {CLIENT_COMMIT} · SRV {server?.commit?.slice(0, 7) || "…"}
      {mismatch && " · ⚠ STALE"}
    </div>
  );
}
